




































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Magistrado from '@/model/Magistrado'
import InvertedSpanTooltip from '@/components/commons/InvertedSpanTooltip.vue'

@Component({ components: { InvertedSpanTooltip } })
export default class ListadoMagistrados extends Vue {
  mounted() {
    if (!this.disabled) {
      this.headers.push({
        text: 'Acciones',
        align: 'center',
        sortable: false,
        width: '10%',
      })
    }
  }

  @Prop()
  private magistrados: Magistrado[]

  @Prop({ type: Boolean, default: false })
  private loading: boolean

  @Prop()
  private pagination: any

  @Prop({ default: false, type: Boolean })
  private disabled: boolean

  editItem(item: Magistrado) {
    this.$emit('edit', item)
  }
  deleteItem(item: Magistrado) {
    this.$emit('delete', item)
  }
  viewItem(item: Magistrado) {
    this.$emit('view', item)
  }

  private localPagination: any = {
    descending: false,
    page: 0,
    rowsPerPage: 5, // -1 for All
  }

  private headers = [
    {
      text: 'Magistrado/a',
      sortable: false,
      width: '50%',
      align: 'center',
    },
    {
      text: 'CUIT/CUIL',
      sortable: false,
      width: '30%',
      align: 'center',
    },
  ]

  @Watch('localPagination')
  paginate(val: any) {
    this.$emit('pagination', val)
  }
}
